import React from 'react'

const Pair_comb = () => {
    return (
        <div className='container'>
            <h1>All pair combinations of 2 tuples</h1>
            <div className='containers'>
            When it is required to find all the pair combinations between two tuples, the list comprehension can be used.
<br /> <br />

Below is the demon libraryation of the same − <br />
<h3>EXAMPLE</h3> </div>
<div className='containers'>
<pre class="prettyprint notranslate prettyprinted" ><span class="keywords">from</span><span class="plain"> itertools </span><span class="keywords">import</span><span class="plain"> product <br />
N </span><span class="plain">=</span><span class="plain"> </span><span class="lit">2</span><span class="plain"><br />
</span><span class="keywords">print</span><span class="plain">(</span><span class="library">"The value of N has been initialized to "</span><span class="plain">)</span><span class="plain"><br />
</span><span class="keywords">print</span><span class="plain">(</span><span class="plain">N</span><span class="plain">)</span><span class="plain"><br />
my_result </span><span class="plain">=</span><span class="plain"> </span><span class="plain">[</span><span class="plain">ele </span><span class="keywords">for</span><span class="plain"> ele </span><span class="keywords">in</span><span class="plain"> product</span><span class="plain">(</span><span class="plain">range</span><span class="plain">(</span><span class="lit">1</span><span class="plain">,</span><span class="plain"> N </span><span class="plain">+</span><span class="plain"> </span><span class="lit">1</span><span class="plain">),</span><span class="plain"> repeat </span><span class="plain">=</span><span class="plain"> N</span><span class="plain">)]</span><span class="plain"><br />
<br />
</span><span class="keywords">print</span><span class="plain">(</span><span class="library">"All tuple combinations until 2 are : "</span><span class="plain"> </span><span class="plain">)</span><span class="plain"><br />
</span><span class="keywords">print</span><span class="plain">(</span><span class="plain">my_result</span><span class="plain">)</span></pre><br />
         </div>  
        </div>
    )
}

export default Pair_comb
